"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiSegmentedCircle16 = {
    paths: [
        {
            path: 'M8,10.8030937 L8,13.8582223 C10.5189979,13.4979079 12.6053719,11.7964838 13.5126432,9.50042902 L10.5803141,8.71471381 C10.0688112,9.73834114 9.13124216,10.511932 8,10.8030937 L8,10.8030937 Z M8,3.05512863 L8,8.8817842e-16 C11.3922941,0.485229661 14,3.40263923 14,6.92911114 C14,7.13940646 13.9907266,7.34753586 13.9725665,7.55311274 L10.9963055,6.755626 C10.920051,4.9686812 9.67142373,3.48532336 8,3.05512863 L8,3.05512863 Z M6,10.8030937 L6,13.8582223 C2.60770586,13.3729926 0,10.4555831 0,6.92911114 C0,3.40263923 2.60770586,0.485229661 6,0 L6,3.05512863 C4.27477279,3.49917142 3,5.06527171 3,6.92911114 C3,8.79295057 4.27477279,10.3590509 6,10.8030937 L6,10.8030937 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Segmented Circle',
    width: 14,
    height: 14,
};
var muiSegmentedCircle24 = {
    paths: [
        {
            path: 'M12,17.9574742 L12,22 C16.3023492,21.6107075 19.8903855,18.734054 21.3268439,14.8131878 L17.4368712,13.7666062 C16.4927973,15.9782449 14.451228,17.6054183 12,17.9574742 L12,17.9574742 Z M12,4.04252576 L12,0 C17.6065,0.507296844 22,5.23846977 22,11 C22,11.638397 21.9460593,12.264144 21.8425045,12.8728964 L17.9521484,11.8262117 C17.9837505,11.5552189 18,11.2795148 18,11 C18,7.4590931 15.3922941,4.52974162 12,4.04252576 L12,4.04252576 Z M10,17.9574742 L10,22 C4.39349999,21.4927032 0,16.7615302 0,11 C0,5.23846977 4.39349999,0.507296844 10,4.36983782e-13 L10,4.04252576 C6.60770586,4.52974162 4,7.4590931 4,11 C4,14.5409069 6.60770586,17.4702584 10,17.9574742 L10,17.9574742 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Segmented Circle',
    width: 22,
    height: 22,
};
var muiSegmentedCircle = {
    base: muiSegmentedCircle16,
    smIcon: muiSegmentedCircle16,
    lgIcon: muiSegmentedCircle24,
};
exports.muiSegmentedCircle = muiSegmentedCircle;
//# sourceMappingURL=segmentedCircle.js.map